import React from "react";
import { useState, useEffect } from "react";
import {
  TableRow,
  TableHead,
  TableContainer,
  Paper,
  TableCell,
  TableBody,
  Table,
  Box,
  TablePagination,
} from "@mui/material";
import dayjs from "dayjs";
import { getAuditingTable } from "../../../services/apiRequests";
import styled from "styled-components";
import useLoader from "../../../Loader/useLoader";
import { useScreenId } from "../../../hooks/useScreenId";
import toast from "react-hot-toast";
const columns = [
  "Application Id",
  "User Name",
  "Country",
  "Screen Name",
  "Action Type",
  "Action Date",
];

const AuditingTable = () => {
  const [totalpages, setTotalPages] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [candidateList, setCandidateDetails] = useState([]);
  const [showLoader, hideLoader] = useLoader();
  useScreenId(
    14,
    () => {
      getAuditing();
    },
    []
  );
  const getAuditing = async () => {
    try {
      showLoader();
      const dataRespond = await getAuditingTable();
      setCandidateDetails(dataRespond.data.content);
      setTotalPages(dataRespond.data.totalElements);
      // dispatch(setNotificationCount(dataRespond.data.totalElements));
    } catch {
      toast.error("Server Error");
    } finally {
      hideLoader();
    }
  };

  const Title = styled(Box)({
    width: "100%",
    fontWeight: "500",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",

    justifyContent: "center",
    alignItems: "center",
    paddingTop: "20px",
    "$ .MuiDataGrid-columnHeaderRow": { backgroundColor: "yellow" },
  });
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const accessType = ["Submited", "Create", "Edit", "View", "Delete"];
  const onChange = (e) => {
    dayjs(e).format("YYYY-MM-DD");
  };

  return (
    <Title>
      <h3 style={{ marginBottom: "20px" }}>Audit Table</h3>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {candidateList && (
          <TableContainer sx={{ width: "90%" }} component={Paper}>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    borderBottom: "1px solid  #D9D9D9",
                    background: "#F7F7F7",
                  }}
                >
                  {columns.map((rowItem) => (
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      {rowItem}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {candidateList.map((objItem) => {
                  return (
                    <TableRow>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          cursor: "pointer",
                          padding: "8px 16px 8px 16px",
                        }}
                      >
                        {objItem.applicationId}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          cursor: "pointer",
                          padding: "8px 16px 8px 16px",
                        }}
                      >
                        {objItem.recruiterName}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          cursor: "pointer",
                          padding: "8px 16px 8px 16px",
                        }}
                      >
                        {objItem.country}
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: "14px",
                          cursor: "pointer",
                          padding: "8px 16px 8px 16px",
                        }}
                      >
                        {objItem.screenDefn}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          cursor: "pointer",
                          padding: "8px 16px 8px 16px",
                        }}
                      >
                        {objItem.actionType}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          cursor: "pointer",
                          padding: "8px 16px 8px 16px",
                        }}
                      >
                        {objItem.actionDate}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
              component="div"
              count={totalpages}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </Box>
    </Title>
  );
};

export default AuditingTable;
